import React, { useEffect, useRef, useState } from "react"
import { Link, graphql, useStaticQuery, navigate } from "gatsby"
import {
    EListingCardLayouts,
    ListingCard,
} from "@organic-return/foundation-react/src/components/Listing/ListingCard"
import { EListingVitalsLayout } from "@organic-return/foundation-react/src/components/Listing/ListingVitals"
import { Search } from "@organic-return/foundation-react/src/components/Search/Search"
import { SiteContext } from "../common/SiteContext"
import { deleteOffMarketListingSession, getOffMarketListingSession, isOffMarketListingSessionActive, setOffMarketListingsSession } from "../../lib/utils"

const OffMarketListingsSearch = (props: any) => {
    const data = useStaticQuery(graphql`
    query {      
      drupalSiteConfiguration {
        offMarketListingsPassword
      }
    }
  `)

    let initialFilter = props.filter?.query

    if (initialFilter) {
        initialFilter = initialFilter.replace(/\+/g, '%20')
        initialFilter = decodeURIComponent(initialFilter)
    }

    let listings: any[] = props.offMarketListings
    
    // Small card size option (default)
    let cardClass = "w-[480px]"
    let cardImageWidth = 480
    // Large card size option
    if (props.cardSize == "large") {
        cardClass = "w-[640px]"
        cardImageWidth = 640
    }

    // Configurable results per page defaults to 20
    let pageSize = props.pageSize || 20

    const inputRef = useRef<any>(null)
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const [authError, setAuthError] = useState(false)
    useEffect(() => {
        if (getOffMarketListingSession()) {
            if (isOffMarketListingSessionActive()) {
                setIsAuthenticated(true)
            }
            else {
                deleteOffMarketListingSession()
            }
        }
    }, [])
    const onButtonClick = () => {
        var inputValue = inputRef.current?.value ?? ""
        if (inputValue == data.drupalSiteConfiguration?.offMarketListingsPassword) {
            setOffMarketListingsSession()
            setIsAuthenticated(true)
        }
        else {
            setAuthError(true)
        }
    }
    const onInput = () => {
        if (authError) {
            setAuthError(false)
        }
    }

    return (
        <>
            {isAuthenticated && (
                <SiteContext.Consumer>{
                    value => {
                        return (
                            <Search
                                index={listings}
                                initialFilter={initialFilter}
                                pageSize={pageSize}
                                pageSizeOpts={[pageSize * 1, pageSize * 2, pageSize * 3, pageSize * 4]}
                                pagerBottom={true}
                                showCount={true}
                                useMap={true}
                                mapClick={item => navigate(item.path)}
                                renderItem={(item, index) => {
                                    return (
                                        <ListingCard
                                            key={index}
                                            listing={item}
                                            layout={EListingCardLayouts.vertical}
                                            className={`${cardClass} max-w-full`}
                                            maxWidthImage={cardImageWidth}
                                            linkImage={true}
                                            linkFunc={props => {
                                                return (
                                                    <Link
                                                        to={props.href ?? ""}
                                                        className={`text-inherit ${props.className}`}
                                                        key={props.key}
                                                        title={props.title}
                                                    >
                                                        {props.children}
                                                    </Link>
                                                )
                                            }}
                                            {...value.globalListingCardProps}
                                            vitalsLayout={
                                                props.cardLayout ||
                                                EListingVitalsLayout.column2Border1
                                            }
                                        />
                                    )
                                }}
                                {...value.listingSearchProps}
                            />
                        )
                    }}
                </SiteContext.Consumer>
            )}
            {!isAuthenticated && (
                <section className="h-screen w-full max-w-screen-md mx-auto flex flex-col gap-y-2 justify-center items-center px-4">
                    <h3 className="self-start">Enter Password to Continue:</h3>
                    <div className="w-full flex flex-col gap-y-2">
                        <input onInput={onInput} ref={inputRef} type="password" className="p-4 w-full border border-body-bg-inverted" />
                        {authError && <span className="md:self-start text-red-500 text-sm">Wrong password</span>}
                        <button onClick={onButtonClick} type="button" className="md:self-end bg-button-bg text-button-text uppercase px-5 py-2">Submit</button>
                    </div>
                </section>
            )}
        </>

    )
}

export default OffMarketListingsSearch

export const query = graphql`
fragment DrupalOffMarketListingsSearchContent on DrupalOffMarketListingsSearch {
    id
    cardLayout
    cardSize
    filter {
        query
    }
    pageSize
    offMarketListings {
        id
        baths
        address {
          city
          street1
          county
          postal
          text
          street2
          state
        }
        beds
        lotacres
        majorArea
        minorArea      
        price
        sqft          
        subType
        subdivision
        exclusive
        features
        flags
        type
        defaultImage {
          dimensions
          url
        }
        path
        location {
          lat
          lng
        }
        garageSpaces
        rooms
        agent {
          mlsID
        }
        office {
          mlsID
        }    
    }
}
`